import styled from "@emotion/styled";
import { Grid2 } from "@mui/material";

const Wrapper = styled.div`
  display: flex;

  flex-direction: column;
  gap: ${p => p.theme.space[5]}px;
`;

const GridContainer = styled(Grid2)`
  justify-content: space-between;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    flex-direction: row;
    align-items: center;
  }
`;

const GridItem = styled(Grid2)`
  display: flex;
  align-items: center;
  gap: ${p => p.theme.space[2]}px;
  margin: 0 10px 6px 0;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    margin-bottom: 0;
  }
`;

const Title = styled.h2`
  margin: 0;
  font-size: 22px;
  color: ${({ theme }) => theme.colors.black};
  font-weight: 500;
  vertical-align: middle;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: 28px;
  }
`;

const Text = styled.p`
  display: inline;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.secondary.gray};

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: 18px;
  }
`;

export { Wrapper, GridContainer, GridItem, Title, Text };
